export const isCampaignLayout = (history) => {
    var res = false;
    ['campaigns'].map((el) => {
        if (history.location.pathname.includes(el)) {
            res = true;
        }
    })
    return res;
}